export default "__VITE_ASSET__BX2w7uuC__"